export default __webpack_public_path__ + "static/masta-ca2d1461f54a5927127f05f554f27aea.webp";